import * as React from 'react';
import { Field } from 'formik';
import { noop } from 'es-toolkit';

import clsx from 'clsx';

import { FormikSelect, FormikTextInput } from '.';
import PhoneCountryCodeSelections from '../constants/PhoneCountryCodeSelections';

export interface Props {
  phoneFieldName: string;
  phoneCountryCodeFieldName: string;
  className?: string;
  disabled?: boolean;
  label?: string;
  warn?: string;
  phonePlaceholder?: string;
  phoneCountryCodePlaceholder?: string;
  onPhoneCountryCodeChange?(evt: React.ChangeEvent<HTMLInputElement>): void;
  onPhoneBlur?(evt: React.FocusEvent<HTMLInputElement>): void;
}

export const FormikPhoneField = React.memo(
  ({
    phoneFieldName,
    phoneCountryCodeFieldName,
    className,
    disabled,
    label,
    warn,
    onPhoneBlur = noop,
    onPhoneCountryCodeChange = noop,
    phoneCountryCodePlaceholder = 'Country code',
    phonePlaceholder = 'Phone number',
  }: Props) => {
    return (
      <Field
        disabled={disabled}
        data-testid="guest-phone"
        label={label}
        className={clsx('TextInput--postfix PhoneInput', className)}
        name={phoneFieldName}
        component={FormikTextInput}
        warn={warn}
        onBlur={onPhoneBlur}
        placeholder={phonePlaceholder}
        prefix={
          <Field
            disabled={disabled}
            name={phoneCountryCodeFieldName}
            component={FormikSelect}
            className="Select--prefix"
            onChange={onPhoneCountryCodeChange}
            options={PhoneCountryCodeSelections}
            placeholder={phoneCountryCodePlaceholder}
          />
        }
        type="tel"
      />
    );
  }
);
